<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: 'SpaRoot',
        metaInfo () {
            // the head belongs to the section that owns the route, and sits on the
            // section's top level record - matched[0] - so the child records keep
            // their own `meta` for their own purposes. Sections that set their head
            // from their page components carry none, and get out of their way.
            const section = this.$route.matched[0];
            const head = section && section.meta && section.meta.head;
            return head ? head.call(this) : {};
        }
    };
</script>
